export default __webpack_public_path__ + "static/media/Logo.921e0867.png";